import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeactivateGuardService } from 'src/app/can-deactivate.guard';
import { AuthGuard } from '../../services/auth.guard';
import { FirmLinkBankingComponent } from '../Engagements/NTR_Dashboard/ntr-dashboard/plaid-connection/firm-link-banking/firm-link-banking.component';
import { WorksheetProceduresComponent } from '../Engagements/NTR_Dashboard/worksheet-procedures/worksheet-procedures.component';
import { FilePreviewComponent } from '../shared/file-preview/file-preview.component';
import { AccountBookComponent } from './account-book/account-book.component';
import { AccountingIntegrationComponent } from './accounting-integration/accounting-integration.component';
import { ClientPortalComponent } from './client-portal/client-portal.component';
import { DailyLoadsComponent } from './daily-loads/daily-loads.component';
import { EngagementPreviewComponent } from './engagementLetter-preview/engagement-preview.component';
import { LoginComponent } from './login/login.component';
import { MytimeTrackerComponent } from './mytime-tracker/mytime-tracker.component';
import { OfficeDocListComponent } from './office-doc-list/office-doc-list.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { SignupComponent } from './signup/signup.component';
import { SourceAttachableComponent } from './source-attachable/source-attachable.component';
import { CashFlowWorkSheetComponent } from './trail-balance-working-sheet/Cash-flow/cash-flow-work-sheet/cash-flow-work-sheet.component';
import { CashFlowWorkStatementComponent } from './trail-balance-working-sheet/Cash-flow/cash-flow-work-statement/cash-flow-work-statement.component';
import { FsNotesComponent } from './trail-balance-working-sheet/fs-notes/fs-notes.component';
import { PartnerCapitalHorizontalComponent } from './trail-balance-working-sheet/partners-capital/partner-capital-horizontal/partner-capital-horizontal.component';
import { PartnerCapitalPreviewComponent } from './trail-balance-working-sheet/partners-capital/partner-capital-preview/partner-capital-preview.component';
import { PartnerCapitalSettingsComponent } from './trail-balance-working-sheet/partners-capital/partner-capital-settings/partner-capital-settings.component';
import { PartnerCapitalVerticalComponent } from './trail-balance-working-sheet/partners-capital/partner-capital-vertical/partner-capital-vertical.component';
import { PartnersCapitalComponent } from './trail-balance-working-sheet/partners-capital/partners-capital.component';
import { RetainedEarningsComponent } from './trail-balance-working-sheet/retained-earnings/retained-earnings.component';
import { StockholdersequityComponent } from './trail-balance-working-sheet/stockholdersequity/stockholdersequity.component';
import { TrailBalanceWorkingSheetComponent } from './trail-balance-working-sheet/trail-balance-working-sheet.component';
import { TrialBalanceLsGroupingComponent } from './trail-balance-working-sheet/trial-balance-ls-grouping/trial-balance-ls-grouping.component';
import { BalanceSheetComponent } from './trail-balance-working-sheet/working-balance-sheet/working-balance-sheet.component';
import { WorkingCashflowComponent } from './trail-balance-working-sheet/working-cashflow/working-cashflow.component';
import { IncomeStatementComponent } from './trail-balance-working-sheet/working-income-statement/working-income-statement.component';
import { onboardingGuard } from '../../services/onboarding.guard';
import { WorkingSchedulesComponent } from './trail-balance-working-sheet/working-schedules/working-schedules.component';

const routes: Routes = [
  {
    path: 'resetpassword',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'setpassword',
    component: SetPasswordComponent
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'signup', component: SignupComponent
  },
  {
    path: 'signup/:type', component: SignupComponent
  },
  {
    path: 'ai-bot',
    loadChildren: () => import('../ai-bot/ai-bot.module').then(m => m.AiBotModule)
  },
  {
    path: '', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'login/:type', component: LoginComponent
  },
  {
    path: 'adj-entry',
    loadChildren: () => import('./adj-entry/adj-entry.module').then(m => m.AdjEntryModule)
  },
  {
    path: 'getting-started',
    loadChildren: () => import('./getting-started/getting-started.module').then(m => m.GettingStartedModule),
    canActivate: [AuthGuard, onboardingGuard]
  },
  {
    path: 'accounting-integration',
    component: AccountingIntegrationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'accountbooks',
    component: AccountBookComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dailyload-details',
    component: DailyLoadsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup?quickbooks=1',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup?xero=1',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup?freshbooks=1',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup?quickbooks=0',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup?xero=0',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup?freshbooks=0',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-account-setup',
    component: ClientPortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'trial-balance-working-sheet',
    component: TrailBalanceWorkingSheetComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'balance-sheet',
        component: BalanceSheetComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fs-notes',
        component: FsNotesComponent,
        canActivate: [AuthGuard],
        canDeactivate: [DeactivateGuardService]
      },
      {
        path: 'income-statement',
        component: IncomeStatementComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'tb-ls-grouping',
        component: TrialBalanceLsGroupingComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'Stockholdersequity',
        component: StockholdersequityComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cf-work-sheet',
        component: CashFlowWorkSheetComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cf-work-statement',
        component: CashFlowWorkStatementComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'partners-capital',
        component: PartnersCapitalComponent,
        canActivate: [AuthGuard],
        children: [{
          path: 'partner-capital-settings',
          component: PartnerCapitalSettingsComponent,
          canActivate: [AuthGuard]
        },
          {
            path: 'partner-capital-horizontal',
            component: PartnerCapitalHorizontalComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'partner-capital-vertical',
            component: PartnerCapitalVerticalComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'partner-capital-preview',
            component: PartnerCapitalPreviewComponent,
            canActivate: [AuthGuard]
          }]
      },
      {
        path: 'cashflow',
        component: WorkingCashflowComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'retained-earnings',
        component: RetainedEarningsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'schedules',
        component: WorkingSchedulesComponent,
        canActivate: [AuthGuard],
        canDeactivate: [DeactivateGuardService]
      }
    ]
  },
  {
    path: 'EngagementPreview',
    component: EngagementPreviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'doc-list',
    component: OfficeDocListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'file-preview/:file-type/:is-inline/:hash/:view-mode/:isReadOnly',
    component: FilePreviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'file-preview/:file-type/:is-inline/:hash/:view-mode',
    component: FilePreviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'mytime-tracker',
    component: MytimeTrackerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'view-procedures/:engagementId/:leadSheetId',
    component: WorksheetProceduresComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'client-banking-financials/:clientKey', component: FirmLinkBankingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'attachable',
    canDeactivate: [DeactivateGuardService],
    component: SourceAttachableComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'attachable/:engagementId/:source',
    canDeactivate: [DeactivateGuardService],
    component: SourceAttachableComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndexRoutingModule {
}
